// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const PurchaseOrderViewLayout = ({ children }) => {

	return (
		<div className='PurchaseOrderViewLayout'>
			
			<Header/>

			<Container>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

PurchaseOrderViewLayout.propTypes = {
	children: PropTypes.node,
}

PurchaseOrderViewLayout.defaultProps = {
	children: null,
}

export default PurchaseOrderViewLayout